import { Box, Button, Card, CardContent, Checkbox, Container, Drawer, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Slide, Typography } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../type/Label';
import { makeStyles } from '@material-ui/core/styles';
import { camelCaseString, validateZipCode } from '../../../utils/format-utils';
import ImageBanner from './ImageBanner';
import { orderIdCard, orderIdCardCleanUp } from '../../../redux/orderIdCards/action';
import { InfoOutlined } from '@mui/icons-material';


const useStylesForDrawer = makeStyles((theme) => {
    return ({
        drawerPaper: {
            [theme.breakpoints.down('sm')]: {
                width: '100vw',
            },
            width: 411,
            backgroundColor: 'transparent'
        },
    });
});

const RequestIdCards = () => {
    const [openRequestDrawer, setOpenRequestDrawer] = useState(false);
    const [successDialog, setSuccessDialog] = useState(false);
    const classes = useStylesForDrawer();
    const [defaultAddressFlag, setDefaultAddressFlag] = useState('DEFAULT');
    const [formIsDisabled, setFormIsDisabled] = useState(true);
    const [memberList, setMemberList] = useState([]);

    const [error, setError] = useState({
        errorForMembers: false,
        errorForMembersText: '',
        errorForZipCodeValid: false,
        errorForZipCodeValidText: '',
    });

    const streetAddressInputRef = useRef(null);
    const aptSuiteInputRef = useRef(null);
    const cityInputRef = useRef(null);
    const zipCodeInputRef = useRef(null);
    const stateInputRef = useRef(null);

    const dispatch = useDispatch();

    const enrollments = useSelector(state => state?.enrollments?.enrollmentsDetails);
    const memberAccounts = useSelector(
        state => state?.memberAccounts?.memberAccountsDetails
    );
    useEffect(()=>{
        dispatch(orderIdCardCleanUp());
    }, []);
    useEffect(() => {
        if (memberAccounts?.self || memberAccounts?.dependents)
            memberAccounts?.self ?
                setMemberList([{ ...memberAccounts.self }, ...memberAccounts.dependents,]) :
                setMemberList([null, ...memberAccounts.dependents]);
    }, [memberAccounts]);

    const changeMemberList = (indexOfMember)=> {
        const updatedMembers = memberList.map((member, index) => indexOfMember === index ? { ...member, includeMember: !member.includeMember } : member);
        setMemberList(updatedMembers);
        setError({...error , errorForMembers: false, errorForMembersText:''});
    };
    const handleOrderSubmit = (event)=> {
        event.preventDefault();
        const groupHeaderArray = [];
     
        memberList.forEach((member)=> {
            if(member.includeMember){
                groupHeaderArray.push(member?.groupId + '-' + member?.subscriberId + '-' + member?.subscriberSuffix);
            }
        });
        if(groupHeaderArray.length === 0){
            setError({...error , errorForMembers: true, errorForMembersText:<Label id="SelectAtleastOneMember" />});
            return;
        }
        if(defaultAddressFlag === 'NOT-DEFAULT' && !validateZipCode(zipCodeInputRef?.current?.value)){
            setError({...error, errorForZipCodeValid: true, errorForZipCodeValidText:'Zip code format should be 12345'});
            return;
        }
        var adressString = '';
        if(defaultAddressFlag === 'DEFAULT'){
            adressString = enrollments?.addressLine1 + '||' + enrollments?.city + '||' + enrollments?.state + '||' + enrollments?.zipCode;
        } 
        else {
            adressString = streetAddressInputRef.current.value.trimEnd() + ' ' + aptSuiteInputRef.current.value.trimEnd() + '||' + cityInputRef.current.value.trimEnd() + '||' + stateInputRef.current.value.trimEnd() + '||' +zipCodeInputRef.current.value.trimEnd();
        }
        dispatch(orderIdCard(groupHeaderArray,localStorage.getItem('tenantHandle'),adressString));
        setOpenRequestDrawer(false);
        setSuccessDialog(true);
        setFormIsDisabled(true);
        setError({
            errorForMembers: false,
            errorForMembersText: '',
            errorForZipCodeValid: false,
            errorForZipCodeValidText: '',
        });
    };
    const handleChange = ()=> {
        let city = cityInputRef?.current?.value;
        let state = stateInputRef?.current?.value;
        let zipCode = zipCodeInputRef?.current?.value;
        if(validateZipCode(zipCode)){
            setError({...error, errorForZipCodeValidText: '', errorForZipCodeValid: false});
        }
        if(!city?.trimEnd() || !state?.trimEnd() || !zipCode?.trimEnd()){
            setFormIsDisabled(true);
        }
        else {
            setFormIsDisabled(false);
        }
    };
   
    return (<>
    <ImageBanner title={<Label id='benefitsIdcard'/>}></ImageBanner>
    {successDialog && <Card className='successCardForSm'>
                <InfoOutlined color='primary' />
                <CardContent className='successCardContent'>
                    <Typography variant='h6'><Label id="ThankYouOrderPlaced." /></Typography>
                    <Typography varaint='body1'><Label id="drawerText2" /></Typography>
                </CardContent></Card>}
        <Box className='requestIDCardBox'>
            <Container className='requestIdCardContainer'>
                <Card className='requestCard'>
                    <Typography variant='h2' className='idCardTitleText'><Label id="medicalIdCards"></Label></Typography>
                </Card>
                <Card className='requestCard'>
                    <Button className='requestCardBtn' id='requestCardBtn' disabled={!(memberList && memberList[0]?.firstName && memberList[0]?.lastName)} onClick={() => setOpenRequestDrawer(true)}>
                        <Label id='requestPrintedCards' />
                    </Button>
                </Card>
            </Container>
            {openRequestDrawer && <Drawer anchor='right' variant='temporary' classes={{ paper: classes?.drawerPaper }} className='drawerForRequestCard' transitionDuration={500} open={openRequestDrawer} onClose={() => setOpenRequestDrawer(false)}>
                <Slide direction='left' in={openRequestDrawer}>
                    <Box className='drawerBox' >
                        <Box className='drawerBoxContent'>
                            <Container className='orderCardHeader'>
                                <Typography variant='h5'><Label id='requestIdCards'></Label></Typography>
                                <HighlightOffIcon onClick={() => setOpenRequestDrawer(false)} />
                            </Container>
                            <Container component='form' className='formContainer' onSubmit={handleOrderSubmit} maxWidth='100%'>
                                <FormControl>
                                    {memberList && memberList[0]?.firstName && memberList.map((member, index) => <FormControlLabel key={index} control={<Checkbox color='primary' checked={member.includeMember || false} onClick={()=> {changeMemberList(index);}} />} label={<Typography color='primary' variant='body1'>{camelCaseString( member?.firstName )+ ' ' +camelCaseString( member?.lastName)}</Typography>}></FormControlLabel>)}
                                </FormControl>
                                <FormHelperText error={error.errorForMembers}>{error.errorForMembersText}</FormHelperText>
                                <FormControl>
                                    <Typography variant='h5'><Label id="shippingAddress" /></Typography>
                                    <RadioGroup aria-label='default-address' value={defaultAddressFlag} onChange={(event) => {
                                        setDefaultAddressFlag(event.target.value);
                                    }}>
                                        <FormControlLabel value={'DEFAULT'} control={<Radio />} label={<Typography color={defaultAddressFlag === 'DEFAULT' ? 'primary' : 'black'} variant='body1'><Label id="defaultAddress" /></Typography>}></FormControlLabel>
                                        {defaultAddressFlag === 'DEFAULT' && <Typography variant='body1' className='defaultAddressText'>
                                            {enrollments?.addressLine1} <br/> {enrollments?.city + ',' + enrollments?.state + ' '+ enrollments?.zipCode}
                                        </Typography>}
                                        <FormControlLabel value={'NOT-DEFAULT'} control={<Radio />} label={<Typography color={defaultAddressFlag === 'NOT-DEFAULT' ? 'primary' : 'black'} variant='body1'><Label id="UseAewAddress"/></Typography>}></FormControlLabel>
                                        {defaultAddressFlag === 'NOT-DEFAULT' && <FormControl className='newAddresContainer'>
                                            <div>
                                                <input className='inputfield' onChange={handleChange} htmlFor='streetAddress' name='streetAddress' ref={streetAddressInputRef}></input>
                                                <label id='streetAddress' className='labelForInput'><Label id="StreetAddress"/></label>
                                            </div>
                                            <div>
                                                <input className='inputfield' onChange={handleChange} htmlFor='apartmentNumber' name='apartmentNumber' ref={aptSuiteInputRef}></input>
                                                <label id='apartmentNumber' className='labelForInput'><Label id="apartment" /></label>
                                            </div>
                                            <div>
                                                <input className='inputfield' onChange={handleChange} htmlFor='city' name='city' required ref={cityInputRef}></input>
                                                <label id='city' className='labelForInput'><Label id="City" /></label>
                                            </div>
                                            <div>
                                                <div>
                                                    <FormHelperText error={error.errorForZipCodeValid}>{error.errorForZipCodeValidText}</FormHelperText>
                                                    <input className='inputfield' onChange={handleChange} htmlFor='zipcode' name='zipcode' required ref={zipCodeInputRef}></input>
                                                    <label id='zipcode' className='labelForInput'><Label id="ZIPCode" /></label>
                                                </div>
                                                <div>
                                                    <input className='inputfield' onChange={handleChange} htmlFor='state'  name='state' required ref={stateInputRef}></input>
                                                    <label id='state' className='labelForInput'><Label id="State" /></label>
                                                </div>
                                            </div>
                                        </FormControl>}
                                    </RadioGroup>
                                </FormControl>
                                <FormControl>
                                    <Button variant='contained' id='submitRequestBtn' className='submitButton' type='submit' 
                                    disabled={defaultAddressFlag === 'NOT-DEFAULT' && formIsDisabled}>
                                        <Label id="submitOrder"></Label>
                                    </Button>
                                </FormControl>
                            </Container>
                            {/* <Typography varaint='body1' className='drawerText'>
                                <Label id='drawerText0'></Label>
                            </Typography> */}
                            <Typography variant='body1' className='drawerText'>
                                <Label id="drawerText1"></Label>
                            </Typography>
                            {/* <Typography variant='body1' className='drawerText'>
                                <Label id="drawerText2"></Label>
                            </Typography> */}
                            <Typography variant='body1' className='drawerText'>
                                <Label id="drawerText3"></Label>
                            </Typography>                            
                            {/* <Typography variant='body' className='drawerText'>
                                <Label id="defaultAddText"></Label>
                            </Typography> */}
                        </Box>
                    </Box>
                </Slide>
            </Drawer>}
        </Box>
        </>
    );
};

export default RequestIdCards;
